const cdnUrlConfig = import.meta.env.VITE_CDN_URL;
const resizeUrlConfig = import.meta.env.VITE_RESIZE_URL;

export const DEFAULT_OPENGRAPH_IMAGE = `${cdnUrlConfig}/static/ogimages/opengraph_card_large.png`;
export const HARDCOVER_LOGO_URL = `${cdnUrlConfig}/static/logos/hardcover-logo-with-text.png`;

// Avatar URLS
export const AVATAR_URL = `${cdnUrlConfig}/static/avatars/profile1.png`;
export const AVATAR_URL_2 = `${cdnUrlConfig}/static/avatars/profile2.png`;
export const AVATAR_URL_3 = `${cdnUrlConfig}/static/avatars/profile3.png`;
export const AVATAR_URL_4 = `${cdnUrlConfig}/static/avatars/profile4.png`;
export const AVATAR_URL_5 = `${cdnUrlConfig}/static/avatars/profile5.png`;
export const AVATAR_URL_6 = `${cdnUrlConfig}/static/avatars/profile6.png`;
export const AUTHOR_AVATAR_URL = `${cdnUrlConfig}/static/avatars/author.svg`;
export const ADAM_AVATAR_URL = `${cdnUrlConfig}/static/avatars/adam.webp`;
export const STE_AVATAR_URL = `${cdnUrlConfig}/static/avatars/ste.jpeg`;

export const DEFAULT_COVER_URL = `${cdnUrlConfig}/static/covers/cover1.png`;
export const PROFILE_COVER_URL = `${cdnUrlConfig}/static/bookHeaders/bookstore.webp`;

export const SampleAvatars = [
  {
    url: AVATAR_URL,
  },
  {
    url: AVATAR_URL_2,
  },
  {
    url: AVATAR_URL_3,
  },
  {
    url: AVATAR_URL_4,
  },
  {
    url: AVATAR_URL_5,
  },
  {
    url: AVATAR_URL_6,
  },
];

export function normalizeImageUrl(url: string) {
  if (!url) return url;
  const normalizeUrl = url
    .replace(
      "https://hardcover-staging.imgix.net",
      "https://storage.googleapis.com/hardcover-staging"
    )
    .replace(
      "https://hardcover.imgix.net",
      "https://storage.googleapis.com/hardcover"
    )
    .replace(
      "https://storage.googleapis.com/hardcover-staging",
      "https://assets-staging.hardcover.app"
    )
    .replace(
      "https://storage.googleapis.com/hardcover",
      "https://assets.hardcover.app"
    );
  return normalizeUrl;
}

export function cdnUrl(path: string) {
  return `${cdnUrlConfig}${path}`;
}

export function enlargeUrl({
  path,
  url,
  width,
  height,
}: {
  url?: string;
  path?: string;
  width: number;
  height: number;
}) {
  if (path) {
    return `${resizeUrlConfig}/enlarge?url=${cdnUrlConfig}${path}&width=${width}&height=${height}&type=webp`;
  } else if (url) {
    return `${resizeUrlConfig}/enlarge?url=${url}&width=${width}&height=${height}&type=webp`;
  }
}

export function cropUrl({
  path,
  url,
  width,
  height,
}: {
  url?: string;
  path?: string;
  width: number;
  height: number;
}) {
  if (path) {
    return `${resizeUrlConfig}/crop?url=${cdnUrlConfig}${path}&width=${width}&height=${height}&type=webp`;
  } else if (url) {
    return `${resizeUrlConfig}/crop?url=${url}&width=${width}&height=${height}&type=webp`;
  }
}